export const PlusIcon = ({ className = 'w-5 h5' }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10c0-4.14-3.36-7.5-7.5-7.5C6.36 2.5 3 5.86 3 10c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M10.5 6.875v6.25M13.625 10h-6.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
